/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "542")
  

// 接口文档

  
    
export interface IAPI76842ReqTargetsItem {
  
  /** 商业收入id */
  commercialIncomeId?: number;
  
  /** TOTAL广告收入 */
  totalAdvertisementIncome?: number;
  
  /** TOTAL代言收入 */
  totalEndorsementIncome?: number;
  
  /** TOTAL活动收入 */
  totalActivityIncome?: number;
  
  /** 艺人到手广告收入 */
  artistNetAdvertisementIncome?: number;
  
  /** 艺人到手代言收入 */
  artistNetEndorsementIncome?: number;
  
  /** 艺人到手活动收入 */
  artistNetActivityIncome?: number;
  
  /** 公司到手广告收入 */
  companyNetAdvertisementIncome?: number;
  
  /** 公司到手收入 */
  companyNetIncome?: number;
  
  /** 公司到手活动收入 */
  companyNetActivityIncome?: number;
  
  /** 分发收入id */
  distributionIncomeId?: number;
  
  /** TOTAL分发收入 */
  totalDistributionIncome?: number;
  
  /** 主播分发收入 */
  anchorDistributionIncome?: number;
  
  /** 公司分发收入 */
  companyDistributionIncome?: number;
  
  /** 直播收入id */
  liveIncomeId?: number;
  
  /** TOTAL直播收入 */
  totalLiveIncome?: number;
  
  /** 主播直播收入 */
  anchorLiveIncome?: number;
  
  /** 公司直播收入 */
  companyLiveIncome?: number;
  
  /** 私域收入id */
  privateDomainIncomeId?: number;
  
  /** TOTAL私域收入 */
  totalPrivateDomainIncome?: number;
  
  /** 主播私域收入 */
  anchorPrivateDomainIncome?: number;
  
  /** 公司私域收入 */
  companyPrivateDomainIncome?: number;
  
};
    
  



export interface API76842Req {
  
  /** 月度目标行 ,MonthSaveTargetReq */
  targets?: IAPI76842ReqTargetsItem[];
};



export type API76842Res = {};


// 接口函数 76842 修改保存IP月度经营目标

export interface IUsePostAPI76842Return {
  /** 修改保存IP月度经营目标: 接口请求状态 */
  isAPI76842Loading: boolean;
  /** 修改保存IP月度经营目标: 接口请求返回数据 */
  dataAPI76842: API76842Res;
  /**  修改保存IP月度经营目标: 接口数据请求方法 */
  fetchAPI76842Data: (inputs: API76842Req, config?: YWRequestConfig) => Promise<API76842Res>;
  /** 修改保存IP月度经营目标: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76842 = ():IUsePostAPI76842Return => {
  let isMount = true;
  const [isAPI76842Loading, setIsAPI76842Loading] = useState(false);
  const [dataAPI76842, setDataAPI76842] = useState<API76842Res>({} as API76842Res);
  const requestUrl = `${basePath}/yoaichat-web/monthIPTarget/save`;

  const fetchAPI76842Data = async (inputs: API76842Req, config?: YWRequestConfig): Promise<API76842Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76842Req>) || {}) as API76842Req;
    
  
    if ( isMount ) {
      setIsAPI76842Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76842Res>(`${basePath}/yoaichat-web/monthIPTarget/save`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76842(res || {} as API76842Res);
        setIsAPI76842Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76842Loading(false);
      }
      return false as unknown as API76842Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76842Loading,
    dataAPI76842,
    fetchAPI76842Data,
    requestUrl,
  }
}

